import { useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import Review from "../../../core/review";
import AdminButton from "../../../core/admin/adminButton";
import AdminField, { AdminTextarea } from "../../../core/admin/adminField";
import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useAuth } from "../../../../context/authProvider";

export default function RequestModal({ review, request, close, refresh, goodToast, badToast }: { review: { id: string, rate: number; review: string; createdAt: Date; }, request: {id: string, review: string} | undefined, close: () => void, refresh: () => void, goodToast: () => void, badToast: () => void }) {

    const { userId } = useAuth();

    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);
    

    const handleReason = (value: string) => {
        if (value.length > 152) {
            return null;
        }
        setReason(value)
    }

    const handleRequest = async () => {
        try {
            setLoading(true);
            if(request?.id){
                await updateDoc(doc(db, "reviewsrequests", request.id), {solved: false, reason});
            }
            else{
                await addDoc(collection(db, "reviewsrequests"), {
                    advertiser: userId,
                    review: review.id,
                    reason,
                    createdAt: serverTimestamp(),
                    solved: false
                })
            }
            setLoading(false);
            refresh();
            goodToast();
            close();

            return null;

        } catch (error) {
            console.log(error);
            badToast();
            setLoading(false);
        }
    }

    return (
        <AdminModal
            close={close}
            title="Por que essa avaliação deve ser excluída?"
            subtitle="A solicitação é analisada pela equipe do GMT-3."
            footer={
                <>
                    <AdminButton variant="secondary" disabled={loading} onClick={close}>Cancelar</AdminButton>
                    <AdminButton loading={loading} disabled={reason === ""} onClick={handleRequest}>Enviar solicitação</AdminButton>
                </>
            }
        >
            <div className="flex flex-col gap-4">
                <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
                    <Review review={review} />
                </div>
                <AdminField label="Escreva abaixo o motivo:" htmlFor="request-reason" required counter={{ current: reason.length, max: 152 }}>
                    <AdminTextarea id="request-reason" disabled={loading} value={reason} onChange={e => handleReason(e.target.value)} />
                </AdminField>
            </div>
        </AdminModal>
    )
}
